import React from "react";
import EmployeeStatusTable from "./EmployeeStatusTable";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { useRecoilValue } from "recoil";
import { PERMISSIONS } from "../../../PermissionsConstants";

const EmployeeStatus = () => {
  const viewPermission =
    PERMISSIONS.permission_utilities_employeetype_employeestatus_view;
  const userPermissions = useRecoilValue(permissionsSelector);
  return (
    <>
      {userPermissions.includes(viewPermission) ? <EmployeeStatusTable /> : ""}
    </>
  );
};

export default EmployeeStatus;
